var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--grey-darken-33)",
  d: "M18.984 21V6.984H8.015V21zm0-15.984q.797 0 1.406.586t.609 1.383v14.016q0 .797-.609 1.406t-1.406.609H8.015q-.797 0-1.406-.609T6 21.001V6.985q0-.797.609-1.383t1.406-.586zm-3-4.032V3h-12v14.016H2.015V3q0-.797.586-1.406T3.984.985z"
})));
export default SvgCopy;